export default "__VITE_ASSET__BXD5j_ho__"